import { useDirectorySearchContext } from '../contexts/DirectorySearchContext';
import { Typography, Box, Button } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { FeaturesTheme } from '../../global/styles/FeaturesTheme';
import { DirectoryResource } from '../constants/DirectoryResource'

/**
 * AgreementOfTerms Component
 * 
 * This component handles the display of the initial agreement of terms.
 * It displays a message asking the user to agree to the terms and conditions,
 * and provides a link to the terms and conditions document.
 * 
 * When the user clicks the "Accept" button, the `setHasAgreed` function from the `DirectorySearchContext` is called to update the state.
 * 
 * Example usage:
 * ```tsx
 * <AgreementOfTerms />
 * ```
 * 
 * @returns {JSX.Element} A component displaying the agreement of terms.
 */
export default function AgreementOfTerms() {
    const { setHasAgreed } = useDirectorySearchContext();

    return (
        <ThemeProvider theme={FeaturesTheme}>
            <Box className="agreement-of-terms" sx={{ textAlign: 'left', maxWidth: '100%', margin: 'auto' }}>
                <Box className="agreement-of-terms-content" sx={{ textAlign: 'left', maxWidth: '100%', margin: '0', p:5 }}>
                    <Typography variant="subtitle2">{DirectoryResource.terms_lbl}</Typography>
                        <Typography variant="body2" sx={{ marginTop: 2, marginBottom: 5 }}>
                            {DirectoryResource.agree_prefix}
                            <a href={DirectoryResource.terms_link} target="_blank" rel="noreferrer">
                                {DirectoryResource.agree_link_text}
                            </a>
                            {DirectoryResource.agree_suffix}
                        </Typography>
                      <Button
                        variant='contained'
                        color="primary"
                        sx={{ justifyContent: 'left', marginBottom: 5, fontSize:"1.25rem" }}
                        onClick={() => setHasAgreed(true)}
                    >
                        {DirectoryResource.accept_btn}
                    </Button>
                </Box>
            </Box>
        </ThemeProvider>
    );
}